<script setup lang="ts">
const props = defineProps<{
  image: any
}>()
</script>

<template>
  <img
    class="my-custom-class-for-img"
    :src="useXcdnImage(props.image.url, 'f=rs:fit:400')"
    :alt="props.image.alternativeText"
    :width="props.image.width"
    :height="props.image.height"
  >
</template>
